export const ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://cartodb.com/attributions">CartoDB</a>';

export const MAP_URL = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png';
//export const APIS_BASE_URL= 'https://nextgen.iccs.gr/api';
//export const APIS_BASE_URL=    process.env.NODE_ENV === 'production' ?  'https://nextgen.iccs.gr/api'  : 'http://127.0.0.1:8000/api';
//export const APIS_BASE_URL=   'https://nextgen.iccs.gr/api';


//export const APIS_BASE_URL=  process.env.NODE_ENV === 'production' ?  '/nextgencms/'  : '/'; 
export const APIS_BASE_URL=    process.env.NODE_ENV === 'production' ?  'https://circular.iccs.gr/api'  : 'http://127.0.0.1:8000/api';